import * as logger from 'logger';
import * as tenantApi from 'api/tenant-api';
import * as tenantService from 'services/tenant-service';
import * as connectionStatusService from 'services/connection-status-service';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import {
  GET_TENANT,
  GET_TENANT_ID_EXISTS,
  SAVE_TENANT,
  SAVE_TENANT_ID_EXISTS,
  UPDATE_NMVS_PROVIDER_CREDS,
  UPDATE_TENANT_PREFERENCES,
  ProcessingTenantAction,
  SaveTenantAction,
  UpdateNmvsProviderCredentialsAction,
  UpdateTenantPreferencesAction,
  SetSettingsErrorMessageAction,
  GET_TENANT_FROM_CACHE,
  GetTenantFromCacheAction
} from './actions';
import { translations } from 'types/translations';
import { Tenant } from 'types/tenants/tenant';

const SettingsMiddleware: Middleware = store => next => async action => {

  try {
    switch (action.type) {
      
      case SAVE_TENANT:
        await saveTenant(action);
        break;

      case GET_TENANT:
        await getTenant(store);
        break;
        
      case GET_TENANT_FROM_CACHE:
        await getTenantFromCache(next);
        break;

      case GET_TENANT_ID_EXISTS:
        await getTenantIdExists(next);
        break;

      case UPDATE_TENANT_PREFERENCES:
        await updateTenantPreferences(store, action);
        break;

      case UPDATE_NMVS_PROVIDER_CREDS:
        await updateNmvsProviderCredentials(store, action);
        break;

      default:
        break;
    }

    next(JSON.parse(JSON.stringify(action)));
  }
  catch (e) {
    const error = e as Error;
    logger.error(error, 'SettingsMiddleware');
  }
};

async function getTenant(store: MiddlewareAPI): Promise<void> {
  // get tenantId from indexedDB
  const isOnline = await connectionStatusService.getStatus();
  let tenant: Tenant;

  try {
    if (isOnline) {
      // get tenant from api
      const tenantId = await tenantService.getTenantId();
      tenant = await tenantApi.getTenant(tenantId);
      if (tenant === null) {
        throw Error('Tenant does not exist.');
      } else {
        store.dispatch(new SaveTenantAction(tenant));
      }
    } else {
      // get tenant from indexedDB
      store.dispatch(new GetTenantFromCacheAction);
    }
  }
  catch (error) {
    logger.error(error, 'SettingsMiddleware.getTenantPreferences');
  }
}

async function getTenantFromCache(next: Dispatch): Promise<void> {
  try {
    // get tenant from indexedDB
    const tenant: Tenant = await tenantService.getTenant();

    if (tenant === null) {
      throw Error('Tenant does not exist.');
    } else {
      next(JSON.parse(JSON.stringify(new SaveTenantAction(tenant))));
    }
  }
  catch (error) {
    logger.error(error, 'SettingsMiddleware.getTenantPreferences');
  }
}

async function saveTenant(action: SaveTenantAction): Promise<void> {
  await tenantService.saveTenant(action.tenant);
}

async function getTenantIdExists(next: Dispatch): Promise<void> {
  const tenantId = await tenantService.getTenantId();
  if (tenantId) {
    next({
      type: SAVE_TENANT_ID_EXISTS,
      exists: true
    });
  } else {
    next({
      type: SAVE_TENANT_ID_EXISTS,
      exists: false
    });
  }
}

async function updateTenantPreferences(store: MiddlewareAPI, action: UpdateTenantPreferencesAction): Promise<void> {
  
  store.dispatch(new ProcessingTenantAction());

  try {
    const tenant = await tenantApi.updatePreferences(action.tenantId, action.language);
    store.dispatch(new SaveTenantAction(tenant));
  }
  catch (error) {
    logger.error(error, 'SettingsMiddleware.updateTenantPreferences');
    store.dispatch(new SetSettingsErrorMessageAction(translations.SaveError));
  }
}

async function updateNmvsProviderCredentials(
  store: MiddlewareAPI, action: UpdateNmvsProviderCredentialsAction): Promise<void> {

  store.dispatch(new ProcessingTenantAction());

  try {
    const tenant = await tenantApi.updateNmvsProviderCredentials(action.tenantId, action.nmvsProviderCredentials);
    store.dispatch(new SaveTenantAction(tenant));
  }
  catch (error) {
    logger.error(error, 'SettingsMiddleware.updateNmvsProviderCredentials');
    store.dispatch(new SetSettingsErrorMessageAction(translations.SaveError));
  }
}

export default SettingsMiddleware;



// WEBPACK FOOTER //
// ./src/pages/settings/middleware.ts